import type { TourConfig } from '../../types/tour.types'

// MCP Connector page. Anchors use the view's existing, stable classes / data-test hooks
// (McpConnectorView.vue + McpServerUrl.vue), so no view edits are needed. Teaches what the
// connector is first, then the URL, the AI tools, the setup docs and where to get help.
const mcpConnectorTour: TourConfig = {
  id: 'mcp-connector',
  title: 'Put TAMI inside your AI chat',
  module: 'AI',
  routeName: 'McpConnector',
  order: 11,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Turn your AI chat into a research tool',
      body: 'The **TAMI AI MCP server** lets an AI assistant search TAMI’s index of **71 million companies**, enrich contacts, and detect the carriers and payment processors a business uses — **without leaving the chat**.',
    },
    {
      id: 'server-url',
      target: '.mcp-url',
      placement: 'bottom',
      title: 'Your MCP server URL',
      body: 'This is the address your AI tool connects to: **https://mcp.tami.ai/mcp**. Use **Copy URL**, then paste it when you add the connector in your AI tool.',
    },
    {
      id: 'tools',
      target: '.mcp-tools',
      placement: 'start',
      title: 'Add TAMI to your AI tool',
      body: 'Click **Connect** next to **Claude**, **ChatGPT**, **Google Gemini** or **Copilot** for step-by-step instructions tailored to that tool and your plan.',
    },
    {
      id: 'docs',
      target: '[data-test="mcp-documentation-link"]',
      placement: 'top',
      title: 'Follow the setup steps',
      body: 'Get a TAMI AI account, add the MCP URL to your AI tool, then ask your first question — like *“Find SaaS companies in Berlin with 50 to 200 employees.”* The **MCP documentation** has every tool and setting.',
    },
    {
      id: 'sales',
      target: '[data-test="mcp-talk-to-sales"]',
      placement: 'top',
      title: 'Questions? We can help',
      body: 'Check the **FAQ** for how it works, what it costs and GDPR — or **talk to sales** for a live walk-through of the connector, credits and settings.',
      aiAction: {
        prompt: 'Explain the TAMI MCP connector — what it does, which AI tools it works with, and how I connect it to my AI chat.',
        label: 'Explain the MCP connector',
      },
    },
  ],
}

export default mcpConnectorTour
